import React from "react";
import { SmallCircleButton } from '../../../components/common/SmallCircleButton';

const IncomingCallScreen = (props) => {
	let { rejectCall, acceptCall, from, onClose, videoEnabled, url, meetingId } = props;

	return (
		<div
			className="p-3 rounded overflow-hidden"
			style={{
				backgroundImage: "linear-gradient(#51555a, #272e35)",
			}}
		>
			<div className="flex justify-between">
				<div>
					{/* Optional Settings Button Placeholder */}
				</div>
				{/* <SmallCircleButton
					backgroundColor="#2A2D3C"
					color="#fff"
					iconClass="icon-cross"
					onClick={onClose}
				/> */}
			</div>

			<div className="mt-3 text-center">
				<div className="text-white text-2xl font-bold">
					{from}
				</div>
				<div className="text-green-500 text-sm font-bold">
					IS CALLING...
				</div>
			</div>

			<div className="flex justify-center items-center mt-12">
				<img loading="lazy" src="/img/calling-emptyavatar.png" alt="Avatar" />
			</div>

			<div className="flex justify-center items-center mt-6">
				<div className={`${(url || meetingId) === undefined ? 'pointer-events-none opacity-50' : ''}`}>
					<a
						className="flex justify-center items-center mx-1 mb-2 rounded-full h-[60px] w-[60px] bg-green-500 hover:opacity-90 transition cursor-pointer"
						onClick={(url || meetingId) !== undefined ? acceptCall : undefined}
					>
						{videoEnabled === true ? (
							<i className="fas fa-video text-white text-lg"></i>
						) : (
							<img loading="lazy" src="/img/call-receivecall-btn@2x.png" width="60" alt="Accept Call" />
						)}
					</a>
				</div>

				<a
					className="flex justify-center items-center mx-1 mb-2 rounded-full h-[60px] w-[60px] bg-red-600 hover:opacity-90 transition"
					onClick={rejectCall}
				>
					<img loading="lazy" src="/img/call-endcall-btn@2x.png" width="60" alt="Reject Call" />
				</a>
			</div>
		</div>
	);
};

export default IncomingCallScreen;
